import { TrackingEventType } from '../../constants/tracking-event-type.ts';
import { mapTrackingEventAddCommonAnalyticsData } from '../../mappers/tracking-event-add-common-analytics-data.mapper.ts';
import { mapTrackingEventAddTestingProperty } from '../../mappers/tracking-event-add-testing-property.mapper.ts';
import { mapTrackingEventToAnalyticsType } from '../../mappers/tracking-event-types.mapper.ts';
import { TrackingEvent } from '../../types/tracking.types.ts';

import { getMixpanelTrackerUtil } from './mixpanel.tracker.util.ts';

export class TrackerUtil {
  private static _instance: TrackerUtil;

  static get instance(): TrackerUtil {
    if (!TrackerUtil._instance) {
      TrackerUtil._instance = new TrackerUtil();
    }
    return TrackerUtil._instance;
  }

  private currentUserId?: string;
  private readonly mixpanelTracker = getMixpanelTrackerUtil();

  reset(): void {
    this.currentUserId = undefined;
    this.mixpanelTracker.reset();
  }

  identify(userId: string): void {
    if (userId !== this.currentUserId) {
      this.currentUserId = userId;
      this.mixpanelTracker.identify(userId);
    }
  }

  track(event: TrackingEvent): void {
    const types = mapTrackingEventToAnalyticsType(event.event);
    for (const type of types) {
      switch (type) {
        case TrackingEventType.ANALYTICS: {
          const preparedEvent = mapTrackingEventAddCommonAnalyticsData(mapTrackingEventAddTestingProperty(event));
          this.mixpanelTracker.track(preparedEvent);
          break;
        }
        case TrackingEventType.MARKETING:
          break;
      }
    }
  }

  setUserProperties(properties: Record<string, unknown>): void {
    this.mixpanelTracker.setUserProperties(properties);
  }
}

export const getTrackerUtil = (): TrackerUtil => TrackerUtil.instance;
